const closePopups = () => {
	document.querySelectorAll('.js-popup').forEach((popup) => {
		popup.classList.remove('is-active');
	});

	document.body.classList.remove('overflow-hidden');
};

const openPopup = (popupId) => {
	const popup = document.querySelector(`.js-popup[data-popup="${popupId}"]`);
	
	if (popup) {
		popup.classList.add('is-active');
		localStorage.setItem(`popup-${popupId}`, 'opened');
	}
};

export {openPopup, closePopups}
